import { ProductDetailPage } from '@/components/products/product-detail-page';
import { graceAiProduct } from '@/content/products';

export function GraceAiPage() {
  return <ProductDetailPage product={graceAiProduct} />;
}
